












































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Sticky } from 'vant';
import SearchBar from '@/components/next/SearchBar.vue';
import PickerInput from '../components/PickerInput.vue';
import ListItem from '../components/ListItem.vue';
import { getVoteList, getBaseInfo, getWorkType } from '../api';

Vue.use(List).use(Sticky);

@Component({
  components: {
    SearchBar,
    ListItem,
    PickerInput,
  },
})
export default class Home extends Vue {
  keyword = '';
  loading = false;
  finished = false;
  page = 1;
  searchTimer: any = null;
  list: any[] = [];
  baseInfo: any = {};
  pickerData: string[] = [];
  selectIndex: number = 0;

  get finishedText() {
    let text = '没有更多了~';
    if (this.keyword && !this.list.length) {
      text = '暂无相关数据';
    }
    return text;
  }

  get zanAvaliable() {
    const currentTime = Date.now();
    return currentTime >= Number(this.baseInfo.startTime) * 1000;
  }

  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    this.onGetVoteList();
    const res = await getWorkType();
    this.pickerData.push('不选择分类');
    for (const key in res.data) {
      if (Object.prototype.hasOwnProperty.call(res.data, key)) {
        const element = res.data[key];
        this.pickerData.push(element as string);
      }
    }
  }

  async onGetVoteList() {
    this.loading = true;
    let ret;
    if (this.selectIndex !== 0) {
      ret = await getVoteList(this.page, this.keyword, this.selectIndex);
    } else {
      ret = await getVoteList(this.page, this.keyword);
    }
    this.loading = false;

    if (!ret || !ret.data.length) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...ret.data];
      this.page++;
    }
  }

  resetVoteList() {
    this.list = [];
    this.finished = false;
    this.page = 1;
  }

  onSearch(data: boolean) {
    console.log('handle user search');
    if (data) {
      (this.$refs.picker as PickerInput).value = '不选择分类';
      this.selectIndex = 0;
    }

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => {
      this.resetVoteList();
      this.onGetVoteList();
    }, 200);
  }
  selectData(data: string, index: number) {
    if (index === this.selectIndex) {
      return;
    }
    (this.$refs.search as SearchBar).userInput = '';
    this.keyword = '';
    this.selectIndex = index;
    this.onSearch(false);
  }
  onClear() {
    this.resetVoteList();
    this.onGetVoteList();
  }
  navToDetail(item: any, index: number) {
    this.$routerThen
      .push({
        url: `detail?id=${item.id}`,
      })
      .then((vm) => {
        vm.$on('updateZan', () => {
          this.list[index].votes = Number(this.list[index].votes) + 1;
        });
      });
  }
  increaseZan(index: number) {
    this.list[index].votes = Number(this.list[index].votes) + 1;
  }
}
